<template>
    <div class="container">
        <v-title :lineage="[{'Guides':'guides'}]">
            Notification Template
        </v-title>
        <div class="grid">
            <div class="grid-item grid-item-primary">
                <div class="grid">
                    <div class="grid-item grid-item-full">
                        <div class="tile">
                            <div class="tile-content">
                                <p>
                                    Notification templates allows you to define format and content in an email
                                    notification. We already have created email templates for several scenarios. However
                                    you can customize those templates to meet your business needs.
                                    <br><br>
                                    You can define the content to be display in your notification by using <strong>Template
                                    Placeholders</strong>
                                </p>
                            </div>
                        </div>
                    </div>
                    <div class="grid-item grid-item-full">
                        <template v-for="placeholder in placeholders">
                            <guide-notification-placeholder :placeholder="placeholder"/>
                        </template>
                    </div>
                </div>
            </div>
            <div class="grid-item grid-item-secondary">
                <div class="tile">
                    <div class="tile-title">
                        <h2>Template placeholders</h2>
                    </div>
                    <div class="tile-content">
                        <ul class="list stack-s">
                            <li v-for="placeholder in placeholders" class="list-item">
                                <div><a :href="`#${placeholder.name}`">{{placeholder.name | capitalize}}</a></div>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import vTitle from '@/components/v-title';
    import {complexTypes, placeholders} from './template-placeholders';
    import GuideNotificationPlaceholder from './components/guide-notification-placeholder';

    export default {
        name: 'guide-notification-template',
        components: {
            vTitle,
            GuideNotificationPlaceholder,
        },
        props: {
            urlReference: {
                type: String,
            },
        },
        data() {
            return {
                placeholders,
                complexTypes,
            };
        },
        methods: {
            scrollToBookmark(bookmark) {
                location.href = bookmark;
            },
        },
        mounted() {
            if (this.$route.hash) {
                this.$nextTick(() => {
                    this.scrollToBookmark(this.$route.hash);
                });
            }
        },
    };
</script>
